"use client";

import { useState } from "react";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

const ContactPage = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
    >
      <ContactForm />
    </GoogleReCaptchaProvider>
  );
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    if (!executeRecaptcha) {
      setError("Erreur avec reCAPTCHA. Veuillez recharger la page.");
      setLoading(false);
      return;
    }

    // ✅ Get reCAPTCHA token
    const recaptchaToken = await executeRecaptcha("contact_form");

    try {
      const response = await fetch("/api/submit-contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, recaptchaToken }),
      });

      const data = await response.json();
      if (data.success) {
        setMessage("Votre message a été envoyé avec succès !");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setError(data.error || "Erreur lors de l'envoi du message.");
      }
    } catch (error) {
      setError("Erreur serveur. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="container mx-auto px-4 py-12">
      <h1 className="text-center text-4xl font-bold text-gray-900 dark:text-white">
        Contactez-nous
      </h1>
      <p className="mt-2 text-center text-gray-600 dark:text-gray-300">
        Nous serons ravis de répondre à vos questions.
      </p>

      <div className="mx-auto mt-8 max-w-2xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        {message && (
          <p className="mb-4 text-center text-green-600">{message}</p>
        )}
        {error && <p className="mb-4 text-center text-red-600">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <input
              type="text"
              name="name"
              placeholder="Votre nom"
              className="w-full rounded-lg border p-2"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Votre email"
              className="w-full rounded-lg border p-2"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <textarea
            name="message"
            placeholder="Votre message..."
            className="w-full rounded-lg border p-2"
            value={formData.message}
            onChange={handleChange}
            required
          />

          <button
            type="submit"
            className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-800"
          >
            {loading ? "Envoi en cours..." : "Envoyer"}
          </button>
        </form>
      </div>
    </main>
  );
};

export default ContactPage;
